// import { Container } from '@material-ui/core'
import React,{useState} from 'react'
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import axios from "../../axios";

function AdminSignup() {
  const navigate = useNavigate();
 const [userName, setUserName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const adminsignup = (e) => {
    e.preventDefault();

   const nameRegex = /^[A-Za-z\s]{3,50}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;

    if (!nameRegex.test(userName)) {
      alert("Please enter a valid name (letters only, 3-50 characters).");
      return;
    }

    if (!emailRegex.test(email)) {
      alert("Please enter a valid email address.");
      return;
    }

    if (!passwordRegex.test(password)) {
      alert("Password must be at least 8 characters long and include at least one letter and one number.");
      return;
    }



    axios
      .post("/admins/adminsignup", { email, password, userName })
      .then((res) => alert(res.data.message))
      .catch((err) => console.warn(err));

    navigate("/Admin");
  };
  
  return (
    <Container>
       <Logo onClick={() => navigate("/")}>
         <img src="./GRIN ENERGY.png" alt="Logo" />
      </Logo>
     <FormContainer>
       <h3>Sign-Up</h3>
        <InputContainer>
          <p>User Name</p>
          <input
            type="text"
            placeholder="Enter Name"
            onChange={(e) => setUserName(e.target.value)}
            value={userName}
          />
        </InputContainer>
         <InputContainer>
          <p>Email</p>
          <input
            type="email"
            placeholder="example@gmail.com"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
          />
        </InputContainer>
         <InputContainer>
          <p>password</p>
          <input
            type="password"
            placeholder="********"
            onChange={(e) => setPassword(e.target.value)}
            value={password}
          />
        </InputContainer>
      

        <SignUpButton  onClick={adminsignup}>Create Account in <strong className="grin">GRIN ENERGY</strong></SignUpButton>
     </FormContainer>
 <LoginButton onClick={() => navigate("/Admin")}>
         Have an account, Login
      </LoginButton>
      
    </Container>
  )
}
const Container = styled.div`
  width: 40%;
  min-width: 450px;
  height: fit-content;
  padding: 15px;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Logo = styled.div`
  width: 300px;
  margin-bottom: 20px;
  img {
    width: 100%;
  }
`;

const FormContainer = styled.form`
  border: 1px solid lightgray;
  width: 55%;
  height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px;

  h3 {
    font-size: 28px;
    font-weight: 400;
    line-height: 33px;
    align-self: flex-start;

    margin-bottom: 10px;
  }
`;

const InputContainer = styled.div`
  width: 100%;
  padding: 10px;

  p {
    font-size: 14px;
    font-weight: 600;
  }

  input {
    width: 95%;
    height: 33px;
    padding-left: 5px;
    border-radius: 5px;
    border: 1px solid lightgray;
    margin-top: 5px;

    &:hover {
      border: 1px solid orange;
    }
  }
`;

const SignUpButton = styled.button`
  width: 100%;
  height: 35px;
  font-size: 12px;
  margin-top: 20px;

  &:hover {
    background-color: #dfdfdf;
    border: 1px solid gray;
  }
`;

const LoginButton = styled.button`
  width: 55%;
  height: 35px;
  background-color: #1e3a8a;
  color:white;
  border: none;
  outline: none;
  border-radius: 10px;
  margin-top: 30px;
`;




export default AdminSignup